import axios from 'axios';
import { apiUrl} from'../Config/Config';

const insurance_plan = () => {
    let planLists = [];
    var qs = require('qs');
    var postobject = {
        admin_id:localStorage.getItem('admin_id'),
    };
    axios.post(apiUrl+"insurance/plantypes",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let planlist = res.data.planlist;            
            for(i; i<planlist.length; i++){
                planLists[i] = { value: planlist[i]['id'], label: planlist[i]['title'] };
            }            
        }       
    });
    return planLists;
}

const adpageList =  () => {
    var qs = require('qs');

    let adpageLists = [];

    const postobject = {
        admin_id: localStorage.getItem('admin_id')
    };

    axios.post(apiUrl + "advertisement/adpage_options", qs.stringify(postobject)).then(res => {
        if (res.data.status === "success") {
            const adpageListt = res.data.adspages || [];
            adpageLists.push(...adpageListt.map(item => ({
                value: item.value,
                label: item.label,
                type: item.type
            })));
        }
    }).catch(error => {
        console.error("Error fetching advertisement pages:", error);
    });

    return adpageLists;
};

const categories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const categories1 = () => {
    var qs = require('qs');

    var postobject = {
        type: 'all'
    };

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const guidecategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidecategory/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidesubcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidesubcategory/sub_categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['sub_cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const adcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"advertisement/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}

export const lang = {

    common: {
        title:'Leaa Doctor',
        status_option:[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
        ],
        tabdisplay_option:[
            { value: 'both', label: 'All' },
            { value: 'aiwidget', label: 'Ai Widget' },
            { value: 'normal', label: 'Default' },           
        ],
        
        gender_option: [
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' }
        ],
        insurance_plan_option: insurance_plan(),
        categories_option: categories(),
        categories_option1: categories1(),
        guidecategories_option: guidecategories(),
        guidesubcategories_option: guidesubcategories(),
        ads_field_options: adpageList(),
        adcategories_option: adcategories(),
		/* image_size_option: [
            { value: '250x250', label: '250x250' },
			{ value: '350x350', label: '350x350' },
            { value: '520x520', label: '520X520' }
        ],*/
        image_size_option: [
            { value: '1031x400', label: '1031x400 (W X H)' },
            { value: '250x180', label: '250x180 (W X H)' },
			{ value: '200x150', label: '200x150 (W X H)' },
            { value: '180x120', label: '180x120 (W X H)' }
        ],
        coming_source :[
            { value: '0', label: 'Select' },
            { value: 'friends', label: 'Friends' },
            { value: 'facebook', label: 'Facebook' },
            { value: 'instagram', label: 'Instagram' },
            { value: 'messaging apps', label: 'Messaging Apps' },
            { value: 'website', label: 'Website' },
            { value: 'flyers', label: 'Flyers' },
            { value: 'sms', label: 'Sms' },
            { value: 'newspaper', label: 'Newspapers' },
            { value: 'others', label: 'Others' }
        ],
         field_options :[
            { value: 'home', label: 'Home' },
            { value: 'membership', label: 'Membership' },
            { value: 'memberlist', label: 'Family Members' },
            { value: 'pending', label: 'Pending' },
            { value: 'accepted', label: 'Accepted' },
            { value: 'completed', label: 'Completed' },
            { value: 'viewmap', label: 'View Map' },
            { value: 'order', label: 'Order' },
            { value: 'onlineprovider', label: 'Online Providers' },
            { value: 'schedule', label: 'My Schedule' },
            { value: 'monthly', label: 'Monthly Earning' },
            { value: 'yearly', label: 'Yearly Earning' },
            { value: 'invited', label: 'Invited' },
            { value: 'invitedfriends', label: 'Invited friends' },
            { value: 'users', label: 'User list' },
            { value: 'provider', label: 'Provider list' },
            { value: 'provideravail', label: 'Provider Availability' },
            { value: 'reviews', label: 'Reviews' },
            { value: 'apptrevenue', label: 'Appointment Monthly Revenue' },
            { value: 'apptyrrevenue', label: 'Appointment Yearly Revenue' },

        ],
        // ads_field_options :[
        //     // { value: 'home', label: 'Home' },
        //     // { value: 'pending', label: 'Pending' },
        //     // { value: 'accepted', label: 'Accepted' },
        //     // { value: 'completed', label: 'Completed' },
        //     // { value: 'order', label: 'Order' },            
        //     { value: 'maintab', label: 'Home' },
        //     { value: 'primarycare', label: 'Primary Care' },
        //     { value: 'membership', label: 'Membership' },
        //     { value: 'store', label: 'Store' },
        //     { value: 'myBag', label: 'My Bag' },
        // ],
        guide_field_options :[                      
            { value: 'maintab', label: 'Home' },
            { value: 'primarycare', label: 'Primary Care' },
            { value: 'membership', label: 'Membership' },
            { value: 'store', label: 'Store' },
            // { value: 'pending', label: 'Pending' },
            // { value: 'accepted', label: 'Accepted' },
            // { value: 'completed', label: 'Completed' },
            { value: 'myBag', label: 'My Bag' },
        ],
        company_field_options :[     
            { value: 'recommendedproduct', label: 'Recommended product' },    
            { value: 'provider', label: 'Provider list' },
            { value: 'provideravail', label: 'Provider Availability' },
            { value: 'pending', label: 'Pending' },
            { value: 'accepted', label: 'Accepted' },
            { value: 'completed', label: 'Completed' },           
            { value: 'monthly', label: 'Monthly Earning' },
            { value: 'yearly', label: 'Yearly Earning' },
            { value: 'users', label: 'User list' },
            { value: 'order', label: 'Order' },
            { value: 'reviews', label: 'Reviews' },
            { value: 'emrpanel', label: 'EMR Panel' },            
            { value: 'recommendproduct', label: 'Recommend Product' },     
            { value: 'manage_user_roles', label:'Manage User Roles'},        
            { value: 'user_roles', label:'User Roles'},   
            { value: 'dispute', label:'Dispute '},        
            { value: 'clinic', label:'clinic '},   
            { value: 'medical_history_summary', label: 'Medical Summary' },
      
        ],
        user_field_options :[
            { value: 'profile', label: 'Profile' },
            { value: 'book', label: 'Book a home visit' },
            { value: 'invited', label: 'Invited' },
            { value: 'friends', label: 'friends' },
            { value: 'memberlist', label: 'Family Members' },
            { value: 'order', label: 'Order' },
            { value: 'viewmap', label: 'View Map' },          
            { value: 'pending', label: 'Pending' },
            { value: 'accepted', label: 'Accepted' },
            { value: 'completed', label: 'Completed' },

            { value: 'direct_visit_pending', label: 'Direct Visit Pending Appt' },
            { value: 'direct_visit_accepted', label: 'Direct Visit Accepted Appt' },
            { value: 'direct_visit_completed', label: 'Direct Visit  Completed Appt' },


            { value: 'paymentcard', label: 'Payment Cards' },
            { value: 'invitefriends', label: 'Invite Friends' },
            { value: 'membership', label: 'Membership' },  
            { value: 'medical_history_summary', label: 'Medical Summary' },  
            { value: 'evaluation_enquiry', label: 'Evaluation Enquiry' },       
        ],
        doctor_field_options :[
            { value: 'profile', label: 'Profile' },
            { value: 'recommendedproduct', label: 'Recommended Product' },
            { value: 'yearly', label: 'Yearly Earning' },
            { value: 'monthly', label: 'Monthly Earning' },
            { value: 'apptrevenue', label: 'Appointment Revenue' },
            { value: 'pending', label: 'Pending' },
            { value: 'accepted', label: 'Accepted' },
            { value: 'completed', label: 'Completed' },
            { value: 'schedule', label: 'My Schedule' },
            { value: 'onlineprovider', label: 'Online Providers' },
            { value: 'recommendproduct', label: 'Recommend Product' },
            { value: 'account_management', label: 'Account Management' },
            { value: 'revenue', label: 'Revenue Management' },
            // { value: 'mybagorder', label: 'Mybag Orders' },
            // { value: 'mybag', label: 'Mybag list' },
            { value: 'refillrequest', label: 'Refill request' },
            { value: 'apptyrrevenue', label: 'Appointment Yearly Revenue' },
             { value: 'medical_history_summary', label: 'Medical Summary' }, 
        ],

        clinic_field_options :[
            { value: 'profile', label: 'Profile' },          
            { value: 'yearly', label: 'Yearly Earning' },
            { value: 'monthly', label: 'Monthly Earning' },
            // { value: 'apptrevenue', label: 'Appointment Revenue' },
            { value: 'pending', label: 'Pending' },
            { value: 'accepted', label: 'Accepted' },
            { value: 'completed', label: 'Completed' },
            // { value: 'schedule', label: 'My Schedule' },
            // { value: 'onlineprovider', label: 'Online Providers' },
            // { value: 'recommendproduct', label: 'Recommend Product' },
            { value: 'account_management', label: 'Account Management' },
            { value: 'revenue', label: 'Revenue Management' },
            // { value: 'mybagorder', label: 'Mybag Orders' },
            // { value: 'mybag', label: 'Mybag list' },
            // { value: 'refillrequest', label: 'Refill request' },
            // { value: 'apptyrrevenue', label: 'Appointment Yearly Revenue' },
        ],
        
        discount_option:[
            { value: 'percentage', label: 'Percentage' },
            { value: 'standard', label: 'Standard' },
        ],
        login_type:[
            { value: 'User', label: 'User' },
            { value: 'Provider', label: 'Provider' },
            { value: 'Company', label: 'Company' },
        ],
        account_type:[
            { value: 'Guest', label: 'Guest' },
            { value: 'User', label: 'User' },
            { value: 'Provider', label: 'Provider' },
            { value: 'Clinic', label: 'Clinic' },
            { value: 'Company', label: 'Company' },
        ],
        account_mang:[
            // { value: 'Guest', label: 'Guest' },
            { value: 'User', label: 'User' },
            { value: 'Provider', label: 'Provider' },
            { value: 'Clinic', label: 'Clinic' },
            { value: 'Traveler', label: 'Traveler' },
        ],
        module_option:[
            { value: 'module1', label: 'Provider Listing' },
            { value: 'module2', label: 'Product Listing' },
            { value: 'module4', label: 'Ebag Products' },
            { value: 'module5', label: 'Clinic Listing' },
            { value: 'module6', label: 'Traveler Listing' },
            { value: 'book', label: 'Book a Home Visit' },
            { value: 'ai', label: 'AI Chat' },
            { value: 'dashboard', label: 'Dashboard' },
            { value: 'ads', label: 'Ads' },
            { value: 'guide', label: 'Guide' },
            { value: 'users', label: 'Users' },
            { value: 'provider', label: 'Providers' },
        ],
        productType_option:[
            { value: '1', label: 'Normal Product' },
            { value: '2', label: 'Shopping Product' },
            { value: '3', label: 'Regular Product' },
        ],
        product_show:[
            { value: 'user', label: 'User' },
            { value: 'doctor', label: 'Doctor' },
        ],
        advertisement_linktype:[
            { value: 'internal', label: 'Internal' },
            { value: 'external', label: 'External' },
            { value: 'offer', label: 'Offers' },
        ], offer_linktype:[
            { value: 'internal', label: 'Internal' },
            { value: 'external', label: 'External' },
            { value: 'product', label: 'Product' },
        ],
        linktype:[
            { value: 'internal', label: 'Internal' },
            // { value: 'external', label: 'External' },
            // { value: 'product', label: 'Product' },
        ],

        shortcuticon_options :[     
            { value: 'ai', label: 'AI' },
            { value: 'guide', label: 'Guide' },
            { value: 'book', label: 'Book' },
            { value: 'pending', label: 'Pending Appt' },
            { value: 'accepted', label: 'Accepted Appt' },
            { value: 'completed', label: 'Completed Appt' },  
            { value: 'profile', label: 'Profile' },            
            { value: 'dashboard', label: 'Dashboard'},             
        ],  
        guestshortcuticon_options :[     
            { value: 'ai', label: 'AI' },
            { value: 'guide', label: 'Guide' },
            { value: 'book', label: 'Book' },                  
        ], 
        faqCategory:[
            {value:'User Conversation',label:'User Conversation'},
            {value:'Doctor Conversation',label:'Doctor Conversation'},
            {value:'Company Conversation',label:'Company Conversation'},
            {value:'Guest Conversation',label:'Guest Conversation'},
            {value:'Domain Data',label:'Domain Data'},
        ], 
        dashboard_blocks :[            
            { value: 'block1', label: 'Block A', columncount:4},
            { value: 'block2', label: 'Block B', columncount:4},
            { value: 'block3', label: 'Block C', columncount:3}, 
            { value: 'block4', label: 'Block D', columncount:4},  
        ],
        userTypeOption:[
            { value: 'Guest', label: 'Guest' },
            { value: 'User', label: 'User' },
            { value: 'Provider', label: 'Provider' },
            { value: 'Company', label: 'Company' },
            { value: 'Clinic', label: 'Clinic' },
        ],
    },
    Capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
};


